import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChatAppInstallMode } from '../core/chat-app-install.service';

/**
 * Manual install steps — SPEC-2026-09-internal-chat-pwa (T-36 · RF-15). Shown on
 * platforms that offer no install prompt (iPhone/iPad, Safari on macOS).
 */
@Component({
  selector: 'chat-app-install-steps',
  templateUrl: './chat-app-install-steps.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatAppInstallStepsComponent {

  readonly steps: string[];

  constructor(
    private readonly dialogRef: MatDialogRef<ChatAppInstallStepsComponent>,
    @Inject(MAT_DIALOG_DATA) readonly mode: ChatAppInstallMode,
  ) {
    this.steps = mode === 'macSafari'
      ? ['chatApp.install.macSafariStep1', 'chatApp.install.macSafariStep2', 'chatApp.install.macSafariStep3']
      : ['chatApp.install.iosStep1', 'chatApp.install.iosStep2', 'chatApp.install.iosStep3'];
  }

  close(): void {
    this.dialogRef.close();
  }
}
